// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1B_ns","title":"BackImages_title__1Us34","images":"BackImages_images__2vUw-"};